import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/authContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { completeGoogleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        await completeGoogleCallback(sessionId);
        // Strip the fragment then navigate. We use the parsed `from` query if present.
        const params = new URLSearchParams(window.location.search);
        const from = params.get("from") || "/boardroom";
        navigate(from, { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed", {
          description: e?.response?.data?.detail || "Please try again.",
        });
        navigate("/login", { replace: true });
      }
    })();
  }, [completeGoogleCallback, navigate]);

  return (
    <div
      data-testid="auth-callback"
      className="flex h-screen w-full items-center justify-center bg-[#F7F7F5]"
    >
      <div className="flex flex-col items-center gap-3">
        <div className="flex h-10 w-10 animate-pulse items-center justify-center rounded-xl bg-gradient-to-br from-zinc-900 to-black">
          <Sparkles className="h-4 w-4 text-white" strokeWidth={2.4} />
        </div>
        <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-zinc-500">
          Signing you in…
        </div>
      </div>
    </div>
  );
}
